import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SliceState, Status } from "../types/common";
import { addCases, executePromise } from "../util/sliceUtil";
import { DataSearchApi } from "../api/DataSearchApi";
import { RootState } from "./index";
import { PageResponse } from "../types/page";
import {
  DatasetMeta,
  TestResultDataObj,
  TestResultItemDataObj,
  TestResultSearchCondition,
} from "../types/dataSearch";

export interface DataSearchState extends SliceState {
  datasets?: DatasetMeta[];
  testResultList?: PageResponse<TestResultDataObj>;
  testResultItemList?: PageResponse<TestResultItemDataObj>;
}

const initialState: DataSearchState = {
  status: Status.IDLE,
};

export const getDatasetsAsync = createAsyncThunk("dataSearch/getDatasets", () =>
  executePromise(DataSearchApi.getDatasets())
);

export const getTestResultListAsync = createAsyncThunk(
  "dataSearch/getTestResultList",
  (condition: TestResultSearchCondition) => executePromise(DataSearchApi.getTestResultList(condition))
);

export const downloadTestResultAsync = createAsyncThunk(
  "dataSearch/downloadTestResult",
  (condition: TestResultSearchCondition) => executePromise(DataSearchApi.downloadTestResult(condition))
);

export const getTestResultItemListAsync = createAsyncThunk(
  "dataSearch/getTestResultItemList",
  (condition: TestResultSearchCondition) => executePromise(DataSearchApi.getTestResultItemList(condition))
);

export const downloadTestResultItemAsync = createAsyncThunk(
  "dataSearch/downloadTestResultItem",
  (condition: TestResultSearchCondition) => executePromise(DataSearchApi.downloadTestResultItem(condition))
);

export const dataSearchSlice = createSlice({
  name: "dataSearch",
  initialState,
  reducers: {
    setDatasets: (state, action: PayloadAction<DatasetMeta[]>) => {
      state.datasets = action.payload;
    },
    setTestResultList: (state, action: PayloadAction<PageResponse<TestResultDataObj>>) => {
      state.testResultList = action.payload;
    },
    setTestResultItemList: (state, action: PayloadAction<PageResponse<TestResultItemDataObj>>) => {
      state.testResultItemList = action.payload;
    },
  },
  extraReducers: (builder) => {
    addCases(builder, getDatasetsAsync);
    addCases(builder, getTestResultListAsync);
    addCases(builder, downloadTestResultAsync);
    addCases(builder, getTestResultItemListAsync);
    addCases(builder, downloadTestResultItemAsync);
  },
});

export default dataSearchSlice.reducer;

export const { setDatasets, setTestResultList, setTestResultItemList } = dataSearchSlice.actions;

export const dataSearchDatasets = (state: RootState) => state.dataSearch.datasets;
export const dataSearchTestResultList = (state: RootState) => state.dataSearch.testResultList;
export const dataSearchTestResultItemList = (state: RootState) => state.dataSearch.testResultItemList;
export const dataSearchStatus = (state: RootState) => state.dataSearch.status;
